module.exports = __webpack_public_path__ + "img/document.5a637d6a.svg";